import { useState, useEffect } from 'react';
import { getTestimonials } from '../../api';
import TestimonialCard from '../shared/TestimonialCard';

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    getTestimonials().then(setTestimonials).catch(() => {});
  }, []);

  if (testimonials.length === 0) return null;

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">What Our <span className="text-blue-600">Clients Say</span></h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't take our word for it. Hear directly from the businesses we've helped grow.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map(t => <TestimonialCard key={t.id} testimonial={t} />)}
        </div>
      </div>
    </section>
  );
}
